module.exports = __webpack_public_path__ + "static/media/noPlace.144c8986.png";